export default {
      id: "ic_back_white-usage",
      viewBox: "0 0 18 18",
      url: "/" + "images/icons.3.109.2.svg#ic_back_white-usage",
      toString: function () {
        return this.url;
      }
    }